let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("138qB")).then(() => parcelRequire('8cr9v'));